import type { ReactNode } from 'react';
import type { WorkbookSheet } from '@erp/shared-types';
import { resultColumns } from '@erp/workbooks';
import { WorkbookSheetChoicesContext } from './workbookSheetChoicesContext';

/** Offers the Workbook's Worksheets to the forms below it that compare one with another. */
export function WorkbookSheetChoicesProvider({
  sheets,
  children,
}: {
  sheets: readonly WorkbookSheet[];
  children: ReactNode;
}) {
  const choices = sheets.map((sheet) => ({
    id: sheet.id,
    name: sheet.name,
    columns: resultColumns(sheet).map((column) => column.name),
  }));
  return (
    <WorkbookSheetChoicesContext.Provider value={choices}>
      {children}
    </WorkbookSheetChoicesContext.Provider>
  );
}
